define(
    'ACS.CommerceCategorySearchResults.CommerceCategorySearchResults',
    [
        'SiteSearch.View',
        'CommerceCategorySearchResults.Plugin',
        'underscore'
    ],
    function(
        SiteSearchView,
        CommerceCategorySearchResultsPlugin,
        _
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp() {
                if (SiteSearchView.prototype._commerceCategorySearchResultsMounted) {
                    return;
                }

                SiteSearchView.prototype._commerceCategorySearchResultsMounted = true;

                SiteSearchView.prototype.initialize = _.wrap(
                    SiteSearchView.prototype.initialize,
                    function initializeSiteSearch(originalInitialize) {
                        originalInitialize.apply(this, _.rest(arguments));
                        CommerceCategorySearchResultsPlugin.install(this.itemsSearcherComponent);
                    }
                );
            }
        };
    }
);
